/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "./js/usadosFunciones";

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $update = _ref.$update;
  var usados = new usadosFunciones(); // Login screen demo data

  var username = '';
  var password = '';

  var updateUsername = function updateUsername(e) {
    username = e.target.value;
    $update();
  };

  var updatePassword = function updatePassword(e) {
    password = e.target.value;
    $update();
  };

  var alertLoginData = function alertLoginData() {
    $f7.dialog.alert('Username: ' + username + '<br/>Password: ' + password, function () {
      $f7.loginScreen.close();
    });
  };

  var sendCredenciales = function sendCredenciales() {
    $f7.request({
      url: usados.servicioGlobal + '/seguridad/login',
      method: 'post',
      data: {
        'user': username,
        'password': password
      },
      success: function success(data, status, xhr) {
        var informacion = JSON.parse(data);

        if (informacion.Error == 0) {
          localStorage.setItem('token', informacion.token);
          localStorage.setItem('idUser', informacion.id_usuario); // Genero listado en pagina principal

          usados.listarVehiculos($f7, 0); // Cierro pantalla de login

          $f7.loginScreen.close();
        } else {
          localStorage.setItem('token', '');
          $f7.dialog.alert(informacion.Error_Msg);
        }
      },
      statusCode: {
        404: function _(xhr) {
          alert('Servicio no encontrado');
        }
      }
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div id="app">

    <!-- Left panel with cover effect-->
    <div class="panel panel-left panel-cover panel-init">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">LNG Olivieri</div>
            </div>
          </div>
          <div class="page-content">
            <!-- <div class="block">
              <p><a href="/logout/" class="panel-close">Cerrar Sesión</a></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Right panel with reveal effect-->
    <div class="panel panel-right panel-reveal theme-dark">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Right Panel</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">Right panel content goes here</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Your main view, should have "view-main" class -->
    <div class="view view-main view-init safe-areas" data-url="/"></div>


    <!-- Popup -->
    <div class="popup" id="my-popup">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Popup</div>
              <div class="right">
                <a href="#" class="link popup-close">Close</a>
              </div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">
              <p>Popup content goes here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Login Screen -->
    <div class="login-screen" id="my-login-screen">
      <div class="view">
        <div class="page" style="background-image: url('./static/images/back_2.jpg');background-position: center bottom; background-repeat: no-repeat;">
          <div class="page-content login-screen-content display-flex flex-direction-column justify-content-center" style="background-color:transparent; margin-top:0px">
            <div class="login-screen-title" style="margin-bottom: -10px;">LNG Olivieri</div>
            <form>
              <div class="list">
                <ul>
                  <li class="item-content item-input">
                    <div class="item-inner">
                      <div class="item-title item-label">Usuario</div>
                      <div class="item-input-wrap">
                        <input type="text" name="username" placeholder="Your username" value="${username}" @input="${updateUsername}"/>
                      </div>
                    </div>
                  </li>
                  <li class="item-content item-input">
                    <div class="item-inner">
                      <div class="item-title item-label">Contraseña</div>
                      <div class="item-input-wrap">
                        <input type="password" name="password" placeholder="Your password" value="${password}" @input="${updatePassword}"/>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="list">
                <ul>
                  <a href="#" class="item-link button button-fill login-button" @click="${sendCredenciales}" style="width: 150px; margin: 0 auto; color: #FFF;">INGRESAR</a>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
`
    }
    ;
}

framework7Component.id = '5a07143b00';
export default framework7Component;